"use strict";

/**
 * @namespace gc.gis.action.digitize
 */
gc.gis.action.digitize = gc.gis.action.digitize || {};

/**
 * Layer-Auswahl-Modus für die Feature-Infofunktion.
 */
gc.gis.module.GCDigitizeConstants = {
	/**
	 * Punkt zeichnen.
	 */
	DRAW_POINT: 1,
	/**
	 * Linie zeichnen.
	 */
	DRAW_LINE: 2,
	/**
	 * Polygon zeichnen.
	 */
	DRAW_POLYGON: 4,
	/**
	 * Rechteck zeichnen.
	 */
	DRAW_RECTANGLE: 8,
	/**
	 * Kreis zeichnen.
	 */
	DRAW_CIRCLE: 16,
	/**
	 * Ellipse zeichnen.
	 */
	DRAW_ELLIPSE: 32,
	/**
	 * Text zeichnen.
	 */
	DRAW_TEXT: 1024,

	/**
	 * Koordinatenobjekte unter neuem Fachobjekt speichern.
	 */
	SAVE_NEW_SINGLE: 1,
	/**
	 * pro Koordinatenobjekt ein neues Fachobjekt anlegen.
	 */
	SAVE_NEW_MULTI: 2,
	/**
	 * Koordinatenobjekt an aktuelles Fachobjekt anhängen.
	 */
	SAVE_APPEND: 4,
	/**
	 * Das aktuelle Koordinatenobjekt überschreiben.
	 */
	SAVE_OVERWRITE: 8,

	/**
	 * keine Auswahl für Selektion getroffen.
	 */
	SELECTION_LAYER_NONE: 0,
	/**
	 * Selektion über sichtbare Layer.
	 */
	SELECTION_LAYER_VISIBLE: 1,
	/**
	 * Selektion über ausgewählte Layer.
	 */
	SELECTION_LAYER_SELECTED: 2,
	/**
	 * Selektion über alle Layer.
	 */
	SELECTION_LAYER_ALL: 3,
	/**
	 * Selektion über einzelnen Layer.
	 */
	SELECTION_LAYER_SINGLE: 4,

	/**
	 * Operation: Pufferbildung
	 */
	OP_BUFFER: 'Buffer',
	/**
	 * Operation: Schwerpunktbildung
	 */
	OP_CENTROID: 'Centroid',
	/**
	 * Operation: konvexe Hülle
	 */
	OP_CONVEX_HULL: 'ConvexHull',
	/**
	 * Operation: Vereinigung
	 */
	OP_UNION: 'Union',
	/**
	 * Operation: Verschneidung
	 */
	OP_INTERSECTION: 'Intersection',
	/**
	 * Operation: Differenz A-B
	 */
	OP_DIFFERENCE_AB: 'DifferenceAB',
	/**
	 * Operation: Differenz B-A
	 */
	OP_DIFFERENCE_BA: 'DifferenceBA',
	/**
	 * Operation: Symmetrische Differenz
	 */
	OP_SYM_DIFFERENCE: 'SymDifference',
	/**
	 * Operation: Verschiebung
	 */
	OP_TRANSLATION: 'Translation',
	/**
	 * Operation: Rotation
	 */
	OP_ROTATION: 'Rotation',
	/**
	 * Operation: Skalierung
	 */
	OP_SCALING: 'Scaling',
	/**
	 * Operation: Validierung
	 */
	OP_VALIDATION: 'Validation',
	/**
	 * Operation: Verschneidung mit Layer
	 */
	OP_INTERSECTION_LAYER: 'IntersectionLayer',
	/**
	 * Operation: Differenz mit Layer
	 */
	OP_DIFFERENCE_LAYER: 'DifferenceLayer'
};

/**
 * Events der Nutzeraktion des FeatureInfo-Moduls.
 * @enum {string}
 */
gc.gis.module.GCDigitizeEvent = {
	/**
	 * Wird ausgelöst, wenn der Objekttyp der Zeichenfunktion geändert wurde.
	 */
	DRAW_TYPE_CHANGED:          'draw:type_changed',
	/**
	 * Wird ausgelöst, wenn der Nutzer ein Objekt eingezeichnet hat.
	 */
	FEATURE_ADDED:              'feature:add',
	/**
	 * Wird ausgelöst, wenn der Nutzer ein Objekt gelöscht hat.
	 */
	FEATURE_REMOVED:            'feature:remove',
	/**
	 * Wird ausgelöst, wenn der Nutzer den alle gezeichneten Objekte gelöscht hat.
	 */
	LAYER_CLEARED:              'layer:cleared',
	/**
	 * Wird ausgelöst, wenn der Nutzer ein Objekt (Fachobjekt oder Koordinaten-Objekt) im Editor geöffnet hat.
	 */
	EDITOR_FEATURE_OPENED:      'editor:feature_opened',
	/**
	 * Wird ausgelöst, wenn der Nutzer den Layer für die Auswahl einer Geometrie geändert hat.
	 */
	SELECTION_LAYER_CHANGED:    'change:selection_layer'
};

/**
 * @classdesc
 * Digitalisierungs-Modul.
 *
 * @class
 * @extends gc.gis.module.GCAbstractModule
 * @memberof gc.gis.module
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {gc.gis.map.GCMapView} [options.map={@link gc.gis.GCApplication#map}] *
 * @param {Object<string,string>} options.requests
 * @param {string} [options.label='Zeichnen / Erfassen']
 */
gc.gis.module.GCDigitize = function(options)
{
	gc.gis.module.GCAbstractModule.call(this, options);

	/**
	 * @type {Object<string,*>}
	 */
	this.options       = options;
	/**
	 * @type {gc.gis.map.GCMapView}
	 */
	this.map           = options.map || gc.gis.iface.map;
	/**
	 * @type {string}
	 */
	this.label         = options.label || 'Zeichnen / Erfassen';
	/**
	 * @type {number}
	 * @private
	 */
	this._drawType = null;

	/**
	 * Transaktioneller Service
	 * @type {gc.gis.service.TransactionFeatureService}
	 */
	this._service = gc.gis.iface.serviceFactory.createTransactionService();

	/**
	 * Implementierung (Controller)
	 * @type {gc.gis.module.GCDigitize.OlImpl}
	 * @private
	 */
	this._impl = new gc.gis.module.GCDigitize.OlImpl({	// FIXME: ggf. über factory?
		instance: this,
		map:      this.map
	});
	this._impl.setTransformActive(false);
	this._impl.setDrawActive(false);

	this._initContent();
	this._initEvents();
};
gc.gis.module.GCDigitize.prototype = Object.create(gc.gis.module.GCAbstractModule.prototype);

/**
 * @return {jQuery}
 */
gc.gis.module.GCDigitize.prototype.getElement = function()
{
	return this._panel_main.getElement();
};

/**
 * Liefert den aktuell eingestellten Zeichenmodus.
 *
 * @public
 * @method
 */
gc.gis.module.GCDigitize.prototype.getDrawType = function()
{
	return this._drawType;
};

/**
 * Liefert den aktuell eingestellten Zeichenmodus.
 *
 * @public
 * @method
 * @return {gc.gis.layer.GCTrackingLayer}
 */
gc.gis.module.GCDigitize.prototype.getLayer = function()
{
	return this._impl.getLayer();
};

/**
 * Setzt den Zeichenmodus.
 *
 * @method
 * @param {Number} type
 */
gc.gis.module.GCDigitize.prototype.setDrawType = function(type)
{
	if (this._drawType !== type)
	{
		this._drawType = type;

		if (this._drawType)
		{
			this._impl.setDrawActive(true);
			switch (this._drawType) {
				case gc.gis.module.GCDigitizeConstants.DRAW_POINT:
					this._impl.setGeometryType(gc.gis.geom.GCGeometryType.POINT);
					break;
				case gc.gis.module.GCDigitizeConstants.DRAW_LINE:
					this._impl.setGeometryType(gc.gis.geom.GCGeometryType.LINESTRING);
					break;
				case gc.gis.module.GCDigitizeConstants.DRAW_POLYGON:
					this._impl.setGeometryType(gc.gis.geom.GCGeometryType.POLYGON);
					break;
				case gc.gis.module.GCDigitizeConstants.DRAW_RECTANGLE:
					this._impl.setGeometryType(gc.gis.geom.GCGeometryType.BOX);
					break;
				case gc.gis.module.GCDigitizeConstants.DRAW_CIRCLE:
					this._impl.setGeometryType(gc.gis.geom.GCGeometryType.CIRCLE);
					break;
				case gc.gis.module.GCDigitizeConstants.DRAW_ELLIPSE:
					gc.gis.iface.log.error(this, 'Typ ELLIPSE not implementet.');
					break;
				case gc.gis.module.GCDigitizeConstants.DRAW_TEXT:
					gc.gis.iface.log.error(this, 'Typ TEXT not implementet.');
					break;
			}
		}
		else
		{
			this._impl.setTransformActive(true)
		}

		this._fireEvent(gc.gis.module.GCDigitizeEvent.DRAW_TYPE_CHANGED, {
			type: this._drawType
		});
	}
};

/**
 * Aktiviert oder deaktiviert das Freihandzeichnen.
 *
 * @param {boolean} enabled
 */
gc.gis.module.GCDigitize.prototype.enableFreehand = function(enabled)
{
	this._impl.enableFreehand(enabled);
};

/**
 * Zeigt einen Dialog zum Speichern der gezeichneten Objekte.
 *
 * @public
 * @method
 */
gc.gis.module.GCDigitize.prototype.openSaveDialog = function()
{
	gc.gis.iface.ui.sidebar.setContent(this._content_save);
};

/**
 * Zeigt einen Dialog zum Speichern der gezeichneten Objekte.
 *
 * @public
 * @method
 */
gc.gis.module.GCDigitize.prototype.openExportDialog = function()
{
	gc.gis.iface.ui.sidebar.setContent(this._content_export);
};

/**
 * Speichert die Objekte.
 *
 * @public
 * @param {gc.gis.layer.GCAbstractLayer} layer Layer
 * @param {number} method Speichermethode
 * @param {Array} geometry_types Geometrietype-Filter für Speicherung
 * @param {string} name Bezeichnung der Geometrie
 * @method
 */
gc.gis.module.GCDigitize.prototype.save = function(layer, method, geometry_types, name)
{
	var i,
		fac_id = -1,    // ID des Fachobjekts, welches aktualisiert werden soll
		geom,
		tmpFeature,
		inFeatures = this._impl.getFeatures(),
		outFeatures = [];

	// betroffene Features raussuchen und erweitern
	for (i = 0; i < inFeatures.length; i++)
	{
		geom = inFeatures[i].getGeometry();
		switch (geom.getType())
		{
			case gc.gis.geom.GCGeometryType.POINT:
				if (geometry_types.indexOf(gc.gis.geom.GCGeometryType.POINT) < 0)
				{
					continue;
				}
				break;
			case gc.gis.geom.GCGeometryType.LINESTRING:
				if (geometry_types.indexOf(gc.gis.geom.GCGeometryType.LINESTRING) < 0)
				{
					continue;
				}
				break;
			case gc.gis.geom.GCGeometryType.POLYGON:
			case gc.gis.geom.GCGeometryType.BOX:
			case gc.gis.geom.GCGeometryType.RECTANGLE:
			case gc.gis.geom.GCGeometryType.CIRCLE:
				if (geometry_types.indexOf(gc.gis.geom.GCGeometryType.POLYGON) < 0)
				{
					continue;
				}
				break;
		}

		// ein Feature mit n-Geometrien
		if (method === gc.gis.module.GCDigitizeConstants.SAVE_NEW_SINGLE)
		{
			if (outFeatures.length < 1)
			{
				outFeatures.push(new gc.gis.service.feature.TransactionFachDBFeature());
			}

			if (name.length > 0)
			{
				outFeatures[0].setAttribute('name', name);
			}

			outFeatures[0].getGeometryList().push({
				geometry: geom
			});
		}
		// n-Feature mit je einer Geometrie
		else
		{
			tmpFeature = new gc.gis.service.feature.TransactionFachDBFeature();
			if (name.length > 0)
			{
				tmpFeature.setAttribute('name', name);
			}

			tmpFeature.getGeometryList().push({
				geometry: geom
			});

			outFeatures.push(tmpFeature);
		}
	}

	switch (method)
	{
		case gc.gis.module.GCDigitizeConstants.SAVE_NEW_SINGLE:
		case gc.gis.module.GCDigitizeConstants.SAVE_NEW_MULTI:
			this._service.addFeature(layer, outFeatures);
			break;
		case gc.gis.module.GCDigitizeConstants.SAVE_APPEND:
		case gc.gis.module.GCDigitizeConstants.SAVE_OVERWRITE:
			this._service.updateFeature(layer, outFeatures, fac_id);
			break;
		default:
			gc.gis.iface.log.error(this, 'Unbekannte Speichermethode angegeben.');
			break;
	}
};

/**
 *
 */
gc.gis.module.GCDigitize.prototype.geoprocess = function(method, opt_options)
{
	var features = this._impl.getFeatures(),
		processor = gc.gis.iface.mapFactory.createGeometryProcessor();

	var isUnary = function (method) {
		return method === gc.gis.module.GCDigitizeConstants.OP_TRANSLATION
			|| method === gc.gis.module.GCDigitizeConstants.OP_ROTATION
			|| method === gc.gis.module.GCDigitizeConstants.OP_SCALING
			|| method === gc.gis.module.GCDigitizeConstants.OP_VALIDATION
			|| method === gc.gis.module.GCDigitizeConstants.OP_BUFFER
			|| method === gc.gis.module.GCDigitizeConstants.OP_CENTROID;
			//|| method === gc.gis.module.GCDigitizeConstants.OP_CONVEX_HULL;   // als Listenoperation ausführen
	};

	var isBinary = function (method) {
		return method === gc.gis.module.GCDigitizeConstants.OP_INTERSECTION
			|| method === gc.gis.module.GCDigitizeConstants.OP_DIFFERENCE_AB
			|| method === gc.gis.module.GCDigitizeConstants.OP_DIFFERENCE_BA
			|| method === gc.gis.module.GCDigitizeConstants.OP_SYM_DIFFERENCE;
	};

	try
	{
		if (isUnary(method))
		{
			this._geoprocessUnary(method, features, processor, opt_options);
		}
		else if (isBinary(method))
		{
			if (features.length > 1)
			{
				this._geoprocessBinary(method, features[0], features.slice(1), processor);
			}
			else
			{
				gc.gis.iface.log.warn(this, 'Die Zeichenfläche enthält nur eine Geometrie. '
					+ 'Es werden min. zwei Geometrien für die Operation benötigt.');
			}
		}
		else
		{
			this._geoprocessList(method, features, processor);
		}
	}
	catch (e)
	{
		gc.gis.iface.log.error(this, 'Bei der Verarbeitung der geometrischen Operation trat ein Fehler auf:\n'
			+ e.message);
	}

};

gc.gis.module.GCDigitize.prototype._geoprocessUnary = function(method, features, processor, opt_options)
{
	var feature,
		i, ii,
		procGeom,
		procResult,
		numValidGeoms = 0;

	if (features.length === 0)
	{
		return;
	}

	for (i = 0, ii = features.length; i < ii; i++)
	{
		feature = features[i];
		procGeom = null;
		procResult = null;

		switch (method)
		{
			case gc.gis.module.GCDigitizeConstants.OP_TRANSLATION:
				procGeom = processor.translate(
					feature.getGeometry(),
					opt_options.delta_x,
					opt_options.delta_y
				);
				break;
			case gc.gis.module.GCDigitizeConstants.OP_ROTATION:
				procGeom = processor.rotate(
					feature.getGeometry(),
					opt_options.angle * (Math.PI / 180)
				);
				break;
			case gc.gis.module.GCDigitizeConstants.OP_SCALING:
				procGeom = processor.scale(
					feature.getGeometry(),
					opt_options.factor_x,
					opt_options.factor_y
				);
				break;
			case gc.gis.module.GCDigitizeConstants.OP_BUFFER:
				procGeom = processor.buffer(
					feature.getGeometry(),
					opt_options.distance,
					opt_options.segments,
					opt_options.cap
				);
				break;
			case gc.gis.module.GCDigitizeConstants.OP_CENTROID:
				procGeom = processor.centroid(feature.getGeometry());
				break;
			case gc.gis.module.GCDigitizeConstants.OP_CONVEX_HULL:
				procGeom = processor.convexHull(feature.getGeometry());
				break;
			case gc.gis.module.GCDigitizeConstants.OP_VALIDATION:
				//procResult = processor.isValid(feature.getGeometry());
				procResult = processor.checkValid(feature.getGeometry());
				if (procResult)
				{
					this.map.showMarker(procResult.message, procResult.coordinate);
				}
				else
				{
					numValidGeoms++;
				}
				break;
		}

		if (procGeom)
		{
			this._applyGeoprocessResult(procGeom, feature);
		}
	}

	// Zusammenfassung bei Validierung
	if (gc.gis.module.GCDigitizeConstants.OP_VALIDATION === method)
	{
		if (features.length === numValidGeoms)
		{
			gc.gis.iface.log.info(this, features.length === 1 ?
				'Die Geometrie ist valide.' : 'Die Geometrien sind valide.');
		}
		else if (numValidGeoms === 0)
		{
			gc.gis.iface.log.warn(this, features.length === 1 ?
				'Die Geometrie ist nicht valide.' : 'Die Geometrien sind nicht valide.');
		}
		else
		{
			var numInvalid = features.length - numValidGeoms;
			gc.gis.iface.log.warn(this, numInvalid + ' von ' + features.length + ' Geometrien ' +
				(numInvalid === 1 ? 'ist' : 'sind') +' nicht valide.');
		}
	}
};

gc.gis.module.GCDigitize.prototype._geoprocessBinary = function(method, featureA, featuresB, processor)
{
	var self = this,
		geometryA = featureA.getGeometry(),
		geometriesB = [],
		procGeom;

	this._impl._transform_interaction.unSelectFeature(featureA);

	featuresB.forEach(function (f) {
		self._impl._transform_interaction.unSelectFeature(f);
		geometriesB.push(f.getGeometry());
	});

	switch (method)
	{
		case gc.gis.module.GCDigitizeConstants.OP_INTERSECTION:
			if (geometriesB.length === 1)
			{
				procGeom = processor.intersection(geometryA, geometriesB[0]);
			}
			else
			{
				procGeom = processor.intersectionList(geometryA, geometriesB);
			}
			break;

		case gc.gis.module.GCDigitizeConstants.OP_DIFFERENCE_AB:
			if (geometriesB.length === 1)
			{
				procGeom = processor.difference(geometryA, geometriesB[0]);
			}
			else
			{
				procGeom = processor.differenceList(geometryA, geometriesB);
			}
			break;

		case gc.gis.module.GCDigitizeConstants.OP_DIFFERENCE_BA:
			if (geometriesB.length === 1)
			{
				procGeom = processor.difference(geometriesB[0], geometryA);
			}
			else
			{
				geometriesB.unshift(geometryA);
				geometryA = geometriesB.pop();
				procGeom = processor.differenceList(geometryA, geometriesB);
			}

			break;

		case gc.gis.module.GCDigitizeConstants.OP_SYM_DIFFERENCE:
			if (geometriesB.length === 1)
			{
				procGeom = processor.symDifference(geometryA, geometriesB[0]);
			}
			else
			{
				procGeom = processor.symDifferenceList(geometryA, geometriesB);
			}
			break;
	}

	if (procGeom)
	{
		this._applyGeoprocessResult(procGeom, featureA);
	}
	else
	{
		this._impl.getLayer().removeFeature(featureA);
	}
	this._impl.getLayer().removeFeatures(featuresB);
};

gc.gis.module.GCDigitize.prototype._geoprocessList = function(method, features, processor)
{
	var geoms = [],
		i, ii,
		procGeom;

	for (i = 0, ii = features.length; i < ii; i++)
	{
		geoms.push(features[i].getGeometry());
	}

	switch (method)
	{
		case gc.gis.module.GCDigitizeConstants.OP_UNION:
			procGeom = processor.cascadedUnion(geoms);
			break;
		case gc.gis.module.GCDigitizeConstants.OP_CONVEX_HULL:
			procGeom = processor.convexHullList(geoms);
			break;
	}

	this._impl._transform_interaction.unSelectFeature(features[0]);
	this._applyGeoprocessResult(procGeom, features[0]);

	for (i = 1, ii = features.length; i < ii; i++)
	{
		this._impl._transform_interaction.unSelectFeature(features[i]);
		this._impl.getLayer().removeFeature(features[i]);
	}
};

/**
 * Stellt die Ergebnis-Geometrie einer geometrischen Operation dem Nutzer zur Verfügung.
 *
 * @param {gc.gis.geom.GCGeometry} procGeom Ergebnis-Geometrie
 * @param {gc.gis.feature.GCFeature} featureApplyTo Feature auf welches die Ergebnis-Geometrie angewendet werden soll
 * @private
 */
gc.gis.module.GCDigitize.prototype._applyGeoprocessResult = function(procGeom, featureApplyTo)
{
	var i, ii, addFeature, geom;

	if (procGeom)
	{
		if (procGeom instanceof gc.gis.geom.GCMultiPoint
			|| procGeom instanceof gc.gis.geom.GCMultiLineString
			|| procGeom instanceof gc.gis.geom.GCMultiPolygon
			|| procGeom instanceof gc.gis.geom.GCGeometryCollection)
		{
			ii = 0;
			if (procGeom instanceof gc.gis.geom.GCMultiPoint) {
				ii =  procGeom.numPoints();
			}
			else if (procGeom instanceof gc.gis.geom.GCMultiLineString) {
				ii =  procGeom.numLineStrings();
			}
			else if (procGeom instanceof gc.gis.geom.GCMultiPolygon) {
				ii =  procGeom.numPolygons();
			}
			else if (procGeom instanceof gc.gis.geom.GCGeometryCollection) {
				ii =  procGeom.numGeometries();
			}

			for (i = 0; i < ii; i++)
			{
				if (procGeom instanceof gc.gis.geom.GCMultiPoint) {
					geom = procGeom.getPoint(i);
				}
				else if (procGeom instanceof gc.gis.geom.GCMultiLineString) {
					geom = procGeom.getLineString(i);
				}
				else if (procGeom instanceof gc.gis.geom.GCMultiPolygon) {
					geom = procGeom.getPolygon(i);
				}
				else if (procGeom instanceof gc.gis.geom.GCGeometryCollection) {
					geom = procGeom.getGeometry(i);
				}

				if (geom)
				{
					if (i === 0)
					{
						featureApplyTo.setGeometry(geom);
					}
					else
					{
						addFeature = gc.gis.iface.mapFactory.createFeature();
						addFeature.setGeometry(geom);
						this._impl.getLayer().addFeature(addFeature);
					}
				}
			}
		}
		else
		{
			featureApplyTo.setGeometry(procGeom);
		}
	}
	else
	{
		// leeres Ergebnis, z.B. bei einer Verschneidung oder neg. Puffer der die Geometrie aufhebt
		this._impl.getLayer().removeFeature(featureApplyTo);
	}
};

/**
 * Initialisiert die Inhaltselemente des Moduls.
 *
 * @private
 */
gc.gis.module.GCDigitize.prototype._initContent = function()
{
	var self = this;

	/**
	 * Haupt-Panel
	 * @type {gc.gis.module.GCDigitize.Panel}
	 * @private
	 */
	this._panel_main = new gc.gis.module.GCDigitize.Panel({
		module: self
	});

	/**
	 * Speichern-Panel
	 * @type {gc.gis.module.GCDigitize.SavePanel}
	 * @private
	 */
	this._panel_save = new gc.gis.module.GCDigitize.SavePanel({
		module: self
	});

	/**
	 * Exportieren-Panel
	 * @type {gc.gis.module.GCDigitize.ExportPanel}
	 * @private
	 */
	this._panel_export = new gc.gis.module.GCDigitize.ExportPanel({
		module: self
	});

	// als Sub-Modul von Tools
	gc.gis.iface.onModuleAvailable(this, 'GCTools', function(module) {
		gc.gis.assert.isInstance(module, gc.gis.module.GCTools);

		/**
		 * Hauptbereich Sidebar-Content
		 * @type {gc.gis.ui.GCSidebarContent}
		 * @private
		 */
		self._content_main = module.addModule(self, self._panel_main.getElement(), 'ms ms-draw');

		/**
		 * Speichern Sidebar-Content
		 * @type {gc.gis.ui.GCSidebarContent}
		 * @private
		 */
		self._content_save = new gc.gis.ui.GCSidebarContent({
			label: 'Objekte speichern',
			'parent': self._content_main,
			launcher: self._content_main.getLauncher(),
			element: self._panel_save.getElement()
		});

		/**
		 * Exportieren Sidebar-Content
		 * @type {gc.gis.ui.GCSidebarContent}
		 * @private
		 */
		self._content_export = new gc.gis.ui.GCSidebarContent({
			label: 'Zeichnung exportieren',
			'parent': self._content_main,
			launcher: self._content_main.getLauncher(),
			element: self._panel_export.getElement()
		});
	});
};

/**
 * Initialisiert die Eventbehandlungsroutinen des Moduls.
 *
 * @private
 */
gc.gis.module.GCDigitize.prototype._initEvents = function()
{
	var self = this;

	// Interaktion (de-)aktivieren, wenn Panel (in-)aktiv
	gc.gis.iface.ui.sidebar.on(gc.gis.ui.GCSidebarEvent.CONTENT_CHANGED, this, function(evt) {
		if(evt.newValue === self._content_main)
		{
			// Modul wird gestartet
			self._impl.setDrawActive(false);
			self._impl.setSelectActive(false);
			self._impl.setTransformActive(true);
		}
		else if(evt.oldValue === self._content_main)
		{
			// Modul wird verlassen
			self.setDrawType(null);
			self._impl.setDrawActive(false);
			self._impl.setTransformActive(false);
			self._impl.setSelectActive(false);
		}
	});

	// Nutzeraktion am Editor (Fachobjekt oder Koordinatenobjekt öffnen)
	// TODO am GCNotificationManager einklinken und Ereignisse überwachen
	//var fac_id = -1, koord_id = -1;
	//this._doEditorAction(fac_id, koord_id);

	// Ereignisse des Nutzers an der Oberfläche
	this._panel_main.getPanelSelect().on(gc.gis.module.GCDigitizeEvent.SELECTION_LAYER_CHANGED, this, function (evt) {
		this._doSelectionLayerChanged(evt.new_mode);
	});

	// Ereignisse der Implementierung der Interaktionen
	this._impl.on(gc.gis.module.GCDigitizeImplEvent.DRAW_END, this, function (evt) {
		this._doDrawEnd(evt);
	});

	// Änderungen am Tracking-Layer
	this._impl.getLayer().on(gc.gis.layer.GCVectorLayerEvent.FEATURE_ADDED, this, function (evt) {
		this._doFeatureAdded(evt.feature);
	});
	this._impl.getLayer().on(gc.gis.layer.GCVectorLayerEvent.FEATURE_REMOVED, this, function (evt) {
		this._doFeatureRemoved(evt.feature);
	});
	this._impl.getLayer().on(gc.gis.layer.GCVectorLayerEvent.LAYER_CLEARED, this, function (evt) {
		this._doTrackingLayerCleared();
	});

	// Events, welche die Service-Implementierung auslöst
	this._service.on(gc.gis.service.FeatureServiceEvent.ADD_SUCCESS, this, function (evt) {
		this._doAddSuccess(evt);
	});
	this._service.on(gc.gis.service.FeatureServiceEvent.UPDATE_SUCCESS, this, function (evt) {
		this._doEditSuccess();
	});
	this._service.on(gc.gis.service.FeatureServiceEvent.DELETE_SUCCESS, this, function (evt) {
		this._doEditSuccess();
	});
	this._service.on(gc.gis.service.FeatureServiceEvent.ADD_ERROR, this, function (evt) {
		gc.gis.iface.log.error(this, 'Beim Speichern trat ein Fehler auf.');
	});
	this._service.on(gc.gis.service.FeatureServiceEvent.UPDATE_ERROR, this, function (evt) {
		gc.gis.iface.log.error(this, 'Beim Aktualisieren trat ein Fehler auf.');
	});
	this._service.on(gc.gis.service.FeatureServiceEvent.DELETE_ERROR, this, function (evt) {
		gc.gis.iface.log.error(this, 'Beim Löschen trat ein Fehler auf.');
	});
};

/**
 * Ereignisbehandlungsroutine die aufgerufen wird, wenn der Nutzer das Zeichnen eines Objekts beendet hat.
 *
 * @params {gc.gis.feature.GCFeature} feature
 * @private
 */
gc.gis.module.GCDigitize.prototype._doDrawEnd = function(evt)
{
	// beim Abschluss eines Zeichenobjekts den Typ auf null setzen, damit alle Button ausgeschaltet werden
	this.setDrawType(null);
};

/**
 * Ereignisbehandlungsroutine die aufgerufen wird, wenn ein Feature zum Tracking-Layer hinzugekommen ist.
 *
 * @params {gc.gis.feature.GCFeature} feature
 * @private
 */
gc.gis.module.GCDigitize.prototype._doFeatureAdded = function(feature)
{
	this._fireEvent(gc.gis.module.GCDigitizeEvent.FEATURE_ADDED, this._createTrackingLayerEvent(feature));
};

/**
 * Ereignisbehandlungsroutine die aufgerufen wird, wenn ein Feature vom Tracking-Layer gelöscht wurde.
 *
 * @params {gc.gis.feature.GCFeature} feature
 * @private
 */
gc.gis.module.GCDigitize.prototype._doFeatureRemoved = function(feature)
{
	this._fireEvent(gc.gis.module.GCDigitizeEvent.FEATURE_REMOVED, this._createTrackingLayerEvent(feature));
};

/**
 * Ereignisbehandlungsroutine die aufgerufen wird, wenn ein Feature vom Tracking-Layer gelöscht wurde.
 *
 * @private
 */
gc.gis.module.GCDigitize.prototype._doTrackingLayerCleared = function()
{
	this._fireEvent(gc.gis.module.GCDigitizeEvent.LAYER_CLEARED, this._createTrackingLayerEvent());
};

/**
 * Ereignisbehandlungsroutine die aufgerufen wird, wenn der Anlegen-Request erfolgreich bearbeitet werden konnte.
 * Das heißt aber noch nicht, das alle Features erfolgreich gespeichert werden konnten.
 *
 * @private
 */
gc.gis.module.GCDigitize.prototype._doAddSuccess = function(evt)
{
	var errors = [],
		numFeatures = evt.features.length,
		msg = '',
		actions = [];

	for (var i = 0; i < numFeatures; i++)
	{
		if (!evt.result[i] || !evt.result[i].success)
		{
			errors.push(evt.result[i].error.message ?
				evt.result[i].error.message : 'Fehler ' + evt.result[i].error.code);
		}
		else
		{
			if (Array.isArray(evt.result[i].actions))
			{
				evt.result[i].actions.forEach(function (a) {
					if (a.type === 'link')
					{
						actions.push(a);
					}
				});
			}
		}
	}

	if (errors.length > 0)
	{
		msg = "Beim Speichern trat ein Fehler auf ("
			+ (numFeatures - errors.length) + " von " + numFeatures + " Objekten gespeichert).\n"
			+ errors.join("\n");
		gc.gis.iface.log.error(this, msg);
		// zeichenfläche nicht leeren, sonst sind die nicht gespeicherten Objekte auch weg
	}
	else
	{
		msg = numFeatures + " Objekt" + (numFeatures > 1 ? "e" : "") + " gespeichert.";
		gc.gis.iface.log.info(this, msg);
		this._impl.saveSuccess();
	}

	if (actions.length > 0)
	{
		var w = window.open(actions[0].request, actions[0].target);
		w.focus();
	}

	this.map.reloadMap(true, false, false); // nur Image-Layer laden, da editierbare Layer als WMS eingebunden sind
};

/**
 * Ereignisbehandlungsroutine die aufgerufen wird, wenn eine Aktualisierung (Anlegen, Ändern, Löschen) erfolgreich war.
 *
 * @private
 */
gc.gis.module.GCDigitize.prototype._doEditSuccess = function()
{
	this._impl.saveSuccess();
	this.map.reloadMap(true, false, false); // nur Image-Layer laden, da editierbare Layer als WMS eingebunden sind
};

/**
 * Ereignisbehandlungsroutine die aufgerufen wird, wenn der Nutzer ein Objekt (Fachobjekt oder Koordinaten-Objekt)
 * im Editor geöffnet hat.
 *
 * @private
 */
gc.gis.module.GCDigitize.prototype._doEditorAction = function(fac_id, koord_id)
{
	this._fireEvent(gc.gis.module.GCDigitizeEvent.EDITOR_FEATURE_OPENED, {
		fac_id: (fac_id > 0 ? fac_id : -1),
		koord_id: (koord_id > 0 ? koord_id : -1)
	});
};

/**
 * Ereignisbehandlungsroutine die aufgerufen wird, wenn der Nutzer ein die Layerauswahl für die Selektion von Objekten
 * geändert hat
 *
 * @param {number} mode ausgewählter Layer-Modus (zurzeit nur Einzelauswahl möglich)
 * @private
 */
gc.gis.module.GCDigitize.prototype._doSelectionLayerChanged = function(mode)
{
	if (mode === gc.gis.module.GCDigitizeConstants.SELECTION_LAYER_SINGLE)
	{
		this._impl.setSelectionLayers([this._panel_main.getPanelSelect().getSelectedLayer()]);
		this._impl.setSelectActive(true);
	}
	else
	{
		this._impl.setSelectionLayers([]);
		this._impl.setSelectActive(false);
	}
};

/**
 * @public
 * @param {Array<gc.gis.feature.GCFeature>} features Liste von Features
 */
gc.gis.module.GCDigitize.prototype.countGeometryTypes = function(features)
{
	var geometryTypeCount = {};

	geometryTypeCount[gc.gis.geom.GCGeometryType.POINT] = 0;
	geometryTypeCount[gc.gis.geom.GCGeometryType.LINESTRING] = 0;
	geometryTypeCount[gc.gis.geom.GCGeometryType.POLYGON] = 0;

	for (var i = 0; i < features.length; i++)
	{
		switch (features[i].getGeometry().getType())
		{
			case gc.gis.geom.GCGeometryType.POINT:
			case gc.gis.geom.GCGeometryType.MULTIPOINT:
				geometryTypeCount[gc.gis.geom.GCGeometryType.POINT]++;
				break;
			case gc.gis.geom.GCGeometryType.LINESTRING:
			case gc.gis.geom.GCGeometryType.LINEARRING:
			case gc.gis.geom.GCGeometryType.MULTILINE:
				geometryTypeCount[gc.gis.geom.GCGeometryType.LINESTRING]++;
				break;
			case gc.gis.geom.GCGeometryType.POLYGON:
			case gc.gis.geom.GCGeometryType.MULTIPOLYGON:
			case gc.gis.geom.GCGeometryType.CIRCLE:
				geometryTypeCount[gc.gis.geom.GCGeometryType.POLYGON]++;
				break;
			//case gc.gis.geom.GCGeometryType.GEOMETRYCOLLECTION: // Collections werden vorab geflated
			// 	break;
		}
	}

	return geometryTypeCount;
};

/**
 * Erzeugt ein Event-Objekt für eine Aktion auf dem Trackinglayer.
 *
 * @param {gc.gis.feature.GCFeature} [feature]
 * @return {Object}
 * @private
 */
gc.gis.module.GCDigitize.prototype._createTrackingLayerEvent = function(feature)
{
	// TODO Typedef
	var evt = {},
		features;

	if (feature)
	{
		evt.feature = feature;
	}

	features = this._impl.getFeatures();
	evt.numFeatures = features.length;

	var geomCountValues = this.countGeometryTypes(features);

	evt[gc.gis.geom.GCGeometryType.POINT] = geomCountValues[gc.gis.geom.GCGeometryType.POINT];
	evt[gc.gis.geom.GCGeometryType.LINESTRING] = geomCountValues[gc.gis.geom.GCGeometryType.LINESTRING];
	evt[gc.gis.geom.GCGeometryType.POLYGON] = geomCountValues[gc.gis.geom.GCGeometryType.POLYGON];

	return evt;
};


///////////////
//  ACTIONS  //
///////////////

/**
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.module
 *
 * @param {gc.gis.module.GCDigitize} module
 * @param {gc.gis.module.GCDigitize.Panel} panel
 * @param {gc.gis.widget.GCToggleSplitButton} button
 */
gc.gis.action.digitize.ToggleDrawMode = function(module, panel, button)
{
	gc.gis.action.GCAbstractAction.call(this);

	this.func = function()
	{
		if(panel && panel.getPanelDraw())
		{
			panel.getPanelSelect().getElement().hide('blind');
			panel.getPanelSelect().getElement().removeClass('active');

			panel.getPanelGeoprocessing().getElement().hide('blind');
			panel.getPanelGeoprocessing().getElement().removeClass('active');

			if (button.isActive())
			{
				panel.getPanelDraw().getElement().show('blind');
				panel.getPanelDraw().getElement().addClass('active');
				module._impl.setDrawActive(true);
			}
			else
			{
				panel.getPanelDraw().getElement().hide('blind');
				panel.getPanelDraw().getElement().removeClass('active');
				module._impl.setTransformActive(true);
			}
		}
	};
	this.args = [];
};
gc.gis.action.digitize.ToggleDrawMode.prototype = Object.create(gc.gis.action.GCAbstractAction.prototype);

/**
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.module
 *
 * @param {gc.gis.module.GCDigitize} module
 * @param {gc.gis.module.GCDigitize.Panel} panel
 * @param {gc.gis.widget.GCRadioItem} button
 */
gc.gis.action.digitize.ToggleSelectMode = function(module, panel, button)
{
	gc.gis.action.GCAbstractAction.call(this);

	this.func = function()
	{
		if(panel && panel.getPanelSelect())
		{
			panel.getPanelDraw().getElement().hide('blind');
			panel.getPanelDraw().getElement().removeClass('active');

			panel.getPanelGeoprocessing().getElement().hide('blind');
			panel.getPanelGeoprocessing().getElement().removeClass('active');

			if (!button.isActive()) // da es ein RadioItem ist, muss der Aktiv-State hier noch umgedreht werden
			{
				panel.getPanelSelect().getElement().show('blind');
				panel.getPanelSelect().getElement().addClass('active');
				module._impl.setSelectActive(true);
			}
			else
			{
				panel.getPanelSelect().getElement().hide('blind');
				panel.getPanelSelect().getElement().removeClass('active');
				module._impl.setTransformActive(true);
			}
		}
	};
	this.args = [];
};
gc.gis.action.digitize.ToggleSelectMode.prototype = Object.create(gc.gis.action.GCAbstractAction.prototype);

/**
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.module
 *
 * @param {gc.gis.module.GCDigitize} module
 * @param {gc.gis.module.GCDigitize.Panel} panel
 * @param {gc.gis.widget.GCRadioItem} button
 */
gc.gis.action.digitize.ToggleProcessingMode = function(module, panel, button)
{
	gc.gis.action.GCAbstractAction.call(this);

	this.func = function()
	{
		if(panel && panel.getPanelGeoprocessing())
		{
			panel.getPanelDraw().getElement().hide('blind');
			panel.getPanelDraw().getElement().removeClass('active');

			panel.getPanelSelect().getElement().hide('blind');
			panel.getPanelSelect().getElement().removeClass('active');

			if (!button.isActive()) // da es ein RadioItem ist, muss der Aktiv-State hier noch umgedreht werden
			{
				panel.getPanelGeoprocessing().getElement().show('blind');
				panel.getPanelGeoprocessing().getElement().addClass('active');
				module._impl.setDrawActive(false);
				module._impl.setSelectActive(false);
				module._impl.setTransformActive(false);
			}
			else
			{
				panel.getPanelGeoprocessing().getElement().hide('blind');
				panel.getPanelGeoprocessing().getElement().removeClass('active');
				module._impl.setTransformActive(true);
			}
		}
	};
	this.args = [];
};
gc.gis.action.digitize.ToggleProcessingMode.prototype = Object.create(gc.gis.action.GCAbstractAction.prototype);